import React, {Suspense} from "react";
import {observer} from "mobx-react";
import CommonUtil from "../../utils/CommonUtil";
import ObjectUtil from "../../utils/ObjectUtil";
import {UIRaonKFileDownloadProps, UIRaonKFileEvents} from "../../types/KFileUploadType";
import DateUtil from "../../utils/DateUtil";
import StringUtil from "../../utils/StringUtil";
import PageLoading from "../loading";
import usePromise from "common/hooks/usePromise";

export default observer(UIRaonKFileDownload);

function UIRaonKFileDownload({
                                 attrs,
                                 className,
                                 onCreationComplete,
                                 onDownloadCancel,
                                 onDownloadCompleteFile,
                                 onDownloadCompleteAllFile,
                                 onSelectItem,
                                 onCustomAction,
                                 onError,
                                 onAlert,
                                 onBeforeOpenFile,
                                 onLanguageDefinition,
                                 value,
                             }: UIRaonKFileDownloadProps) {
    const RAONKUPLOAD = window["RAONKUPLOAD"];
    const RAONKUpload = window["RAONKUpload"];
    const [uploadId] = React.useState("RaonK" + CommonUtil.getUid());
    const [rowAdded, setRowAdded] = React.useState(false);
    const [raonKUploadLoading, raonKUploadResolved] = usePromise(() => new Promise<any>((resolve, reject) => {
        const onCreationCompleteHandler = (uploadId: string) => {
            if (onCreationComplete) {
                onCreationComplete(uploadId)
            }
            resolve(newKUpload);
        }

        const newKUpload = new RAONKUpload({
            Id: uploadId,
            UploadHolder: uploadId,
            IgnoreSameUploadName: "0",
            Width: attr.Width,
            Height: attr.Height,
            ImgPreView: attr.ImgPreView,
            ImgPreViewWidth: attr.ImgPreViewWidth,
            ImgPreViewHeight: attr.ImgPreViewHeight,
            // 기본값 : list, 썸네일 : thumbs
            Views: attr.Views,
            Mode: "view", // edit, view
            // ButtonBarEdit: "add,remove,remove_all", // add,send,remove,remove_all
            ButtonBarView: "download,download_all", // 0 일경우 버튼바 보이지 않음.
            //Lang: "en-us", // ko-kr, en-us, ja-jp, zh-cn, zh-tw
            SilentDownload: "1",
            HeaderBarItem: "등록일시,등록자",
            HeaderBarItemWidth: "130,100",
            UseAlertEvent: attr.UseAlertEvent,
            SimpleUIMode: attr.SimpleUIMode,
            SkinName: attr.SkinName,
            DisableAlertMessage: {
                DisableDeleteConfirm: "1"
            },
            Event: {
                OnError: onErrorHandler,
                CreationComplete: onCreationCompleteHandler,
                DownloadCompleteFile: onDownloadCompleteFile,
                DownloadCompleteAllFile: onDownloadCompleteAllFile,
                SelectItem: onSelectItem,
                CustomAction: onCustomAction,
                BeforeOpenFile: onBeforeOpenFile,
                OnLanguageDefinition: onLanguageDefinition,
                Alert: onAlert
            }
        });
        resolve(newKUpload)

    }), []);


    const attr: any = {...attrs};
    attr.Width = ObjectUtil.defaultIfNull(attr.Width, "100%");
    attr.Height = ObjectUtil.defaultIfNull(attr.Height, "200px");
    attr.ImgPreView = ObjectUtil.defaultIfNull(attr.ImgPreView, "0");
    attr.ImgPreViewWidth = ObjectUtil.defaultIfNull(attr.ImgPreViewWidth, "250px");
    attr.ImgPreViewHeight = ObjectUtil.defaultIfNull(attr.ImgPreViewHeight, "250px;");
    attr.Views = ObjectUtil.defaultIfNull(attr.Views, "list");

    const onErrorHandler = (uploadID: string, paramObj: {
        strCode: string;
        strMessage: string;
        arrUploadedFileList: Array<{
            originName: string;
            fileSize: number;
            uploadName: string;
            uploadPath: string;
            order: number;
        }>;
    }) => {
        console.error("RAONKUpload", "Download", uploadID, paramObj);
        onError && onError(uploadID, paramObj);
    }

    React.useEffect(() => {
        return () => {
            if (raonKUploadResolved) {
                RAONKUPLOAD.Destroy(raonKUploadResolved.ID)
            }
        };
    }, [raonKUploadResolved]);

    React.useEffect(() => {
        if (!raonKUploadLoading) {
            if (rowAdded) {
                RAONKUPLOAD.DeleteAllFile(uploadId);
                setRowAdded(false);
            }

            value?.tbComFileMapngDetailList.forEach((tbComFileMapngDetail, index) => {
                const gubun = '\b';
                const args5 = 'formdatavalue1' + gubun + 'formdatavalue2'
                RAONKUPLOAD.AddUploadedFileEx(
                    tbComFileMapngDetail.getFileDetailId() || String(index),
                    tbComFileMapngDetail.getOrginlFileNm(),
                    tbComFileMapngDetail.getStrePath() + "/" + tbComFileMapngDetail.getStreFileNm(),
                    tbComFileMapngDetail.getFileSize(),
                    "raonok",
                    DateUtil.toDateFormat(tbComFileMapngDetail.getRegistDt(), "yyyy-MM-DD HH:mm:ss") + "|" + StringUtil.defaultIfEmpty(tbComFileMapngDetail.getRegistPsnNm(),""),
                    uploadId,
                );
                setRowAdded(true);
            })
        }
    }, [raonKUploadLoading, value?.tbComFileMapngDetailList])

    return (
        <Suspense fallback={<PageLoading/>}>
            <div id={uploadId} className={className}></div>
        </Suspense>
    );
}
